/**
 * Smooth Scroll Module
 * 
 * @package KateMedia
 */

export function initSmoothScroll() {
    // Плавная прокрутка для якорных ссылок
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    
    anchorLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const targetId = this.getAttribute('href');
            // #form-lead открывает модалку заявки (contact-popup.js), не скроллим.
            if (targetId === '#form-lead') return;

            e.preventDefault();
            
            const targetElement = document.querySelector(targetId);
            
            if (targetElement) {
                const headerHeight = document.querySelector('.header')?.offsetHeight || 0;
                const rect = targetElement.getBoundingClientRect();
                const targetPosition = rect.top + window.pageYOffset - headerHeight - 20;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}
